module.exports = __webpack_public_path__ + "static/media/calendar-icon-focus.364ddd22.svg";